import { hash } from '@ember/helper';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsChannelComponent extends Component {
  // Services
  @service intl;

  // Getter and setter
  get originalLanguageContents() {
    const scope = 'models.plurals';

    return [
      {
        value: 'articles',
        label: this.intl.t(`${scope}.article`),
      },
      {
        value: 'artists',
        label: this.intl.t(`${scope}.artist`),
      },
      {
        value: 'assets',
        label: this.intl.t(`${scope}.asset`),
      },
      {
        value: 'content-collections',
        label: this.intl.t(`${scope}.collection`),
      },
      {
        value: 'jobs',
        label: this.intl.t(`${scope}.job`),
      },
      {
        value: 'labels',
        label: this.intl.t(`${scope}.label`),
      },
      {
        value: 'live-events',
        label: this.intl.t(`${scope}.live-event`),
      },
      {
        value: 'live-partners',
        label: this.intl.t(`${scope}.live-partner`),
      },
      {
        value: 'media-embeds',
        label: this.intl.t(`${scope}.media-embed`),
      },
      {
        value: 'media-events',
        label: this.intl.t(`${scope}.media-event`),
      },
      {
        value: 'media-partners',
        label: this.intl.t(`${scope}.media-partner`),
      },
      {
        value: 'organizations',
        label: this.intl.t(`${scope}.organization`),
      },
      {
        value: 'products',
        label: this.intl.t(`${scope}.product`),
      },
      {
        value: 'product-families',
        label: this.intl.t(`${scope}.product-family`),
      },
      {
        value: 'stories',
        label: this.intl.t(`${scope}.story`),
      },
      {
        value: 'teasers',
        label: this.intl.t(`${scope}.teaser`),
      },
      {
        value: 'trade-partners',
        label: this.intl.t(`${scope}.trade-partner`),
      },
      {
        value: 'web-series',
        label: this.intl.t(`${scope}.web-series`),
      },
    ];
  }

  // Functions
  setDefaultOriginalLanguageContents = () => {
    if (this.args.model.isNew) {
      this.args.model.originalLanguageContents = [
        'assets',
        'content-collections',
        'live-events',
        'media-events',
        'product-families',
        'products',
      ];
    }
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div
        class='o-layout'
        {{didInsert this.setDefaultOriginalLanguageContents}}
      >
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            <fieldset.field
              @property='cmsLanguageId'
              @type='select-value'
              @options={{this.availableLanguages}}
            />

            <fieldset.field
              @property='defaultLanguage'
              @type='select-value'
              @options={{this.availableLanguages}}
            />

            <fieldset.field
              @property='activeLanguages'
              @type='select-multiple'
              @options={{this.availableLanguages}}
            />

            <fieldset.field
              @property='originalLanguageContents'
              @type='select-multiple'
              @options={{this.originalLanguageContents}}
            />

            <fieldset.field @property='name' />
            <fieldset.field @property='text' />
            <fieldset.field @property='virtual' @type='checkbox' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @property='asset'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @property='link'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='legalContext'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channel'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='disableChannelInheritance'
              @type='checkbox'
            />

            <fieldset.field
              @property='linkPatternDownload'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='linkPatternMedium'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='linkPatternStreaming'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='linkPatternMerch'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
